// src/store/purchase-order-new/purchaseOrderActions.js
import axios from "axios";
import Config from "../../config/index";
import {
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_REQUEST,
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_SUCCESS,
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_FAILURE,
  CREATE_PURCHASE_ORDER_FAILURE,
  CREATE_PURCHASE_ORDER_REQUEST,
  CREATE_PURCHASE_ORDER_SUCCESS,
  DELETE_PURCHASE_ORDER_FAILURE,
  DELETE_PURCHASE_ORDER_REQUEST,
  DELETE_PURCHASE_ORDER_SUCCESS,
  EDIT_REQ_QTY_FAILURE,
  EDIT_REQ_QTY_REQUEST,
  EDIT_REQ_QTY_SUCCESS,
  GET_PURCHASE_ORDER_FAILURE,
  GET_PURCHASE_ORDER_REQUEST,
  GET_PURCHASE_ORDER_SUCCESS,
  PUBLISH_PURCHASE_ORDER_FAILURE,
  PUBLISH_PURCHASE_ORDER_REQUEST,
  PUBLISH_PURCHASE_ORDER_SUCCESS,
  GET_NOTACCEPTEDPURCHASEDORDERS_FAILURE,
  GET_NOTACCEPTEDPURCHASEDORDERS_REQUEST,
  GET_NOTACCEPTEDPURCHASEDORDERS_SUCCESS,
  PUBLISH_PO_REQUEST,
  PUBLISH_PO_SUCCESS,
  PUBLISH_PO_FAILURE,
  GET_VENDOR_CODE_REQUEST,
  GET_VENDOR_CODE_SUCCESS,
  GET_VENDOR_CODE_FAILURE,
  UPDATE_ACCEPTPO_REQUEST,
  UPDATE_ACCEPTPO_SUCCESS,
  UPDATE_ACCEPTPO_FAILURE,
  UPDATE_REJECTPO_REQUEST,
  UPDATE_REJECTPO_SUCCESS,
  UPDATE_REJECTPO_FAILURE,
  UPDATE_ACCEPTPO_BULK_REQUEST,
  UPDATE_ACCEPTPO_BULK_SUCCESS,
  UPDATE_ACCEPTPO_BULK_FAILURE,
  UPDATE_REJECTPO_BULK_REQUEST,
  UPDATE_REJECTPO_BULK_SUCCESS,
  UPDATE_REJECTPO_BULK_FAILURE,
  GET_RELEASED_PURCHASE_ORDERS_REQUEST,
  GET_RELEASED_PURCHASE_ORDERS_SUCCESS,
  GET_RELEASED_PURCHASE_ORDERS_FAILURE,
  GET_ACCEPTED_PURCHASE_ORDERS_REQUEST,
  GET_ACCEPTED_PURCHASE_ORDERS_SUCCESS,
  GET_ACCEPTED_PURCHASE_ORDERS_FAILURE,
  GET_DELIVERY_PLANT_FOR_PO_REQUEST,
  GET_DELIVERY_PLANT_FOR_PO_SUCCESS,
  GET_DELIVERY_PLANT_FOR_PO_FAILURE,
  GET_UNLOADING_POINT_FOR_PO_REQUEST,
  GET_UNLOADING_POINT_FOR_PO_SUCCESS,
  GET_UNLOADING_POINT_FOR_PO_FAILURE,
  GET_VENDOR_PURCHASE_ORDER_REQUEST,
  GET_VENDOR_PURCHASE_ORDER_SUCCESS,
  GET_VENDOR_PURCHASE_ORDER_FAILURE,
  GET_CLIENT_REJECTED_POS_REQUEST,
  GET_CLIENT_REJECTED_POS_SUCCESS,
  GET_CLIENT_REJECTED_POS_FAILURE,
  GET_VENDOR_REJECTED_POS_REQUEST,
  GET_VENDOR_REJECTED_POS_SUCCESS,
  GET_VENDOR_REJECTED_POS_FAILURE,
  GET_ACCEPTED_PO_CLIENT_REQUEST,
  GET_ACCEPTED_PO_CLIENT_SUCCESS,
  GET_ACCEPTED_PO_CLIENT_FAILURE,
  GET_ACCEPTED_PO_VENDOR_REQUEST,
  GET_ACCEPTED_PO_VENDOR_SUCCESS,
  GET_ACCEPTED_PO_VENDOR_FAILURE,
  GET_ATTACHMENT_CLIENT_REQUEST,
  GET_ATTACHMENT_CLIENT_SUCCESS,
  GET_ATTACHMENT_CLIENT_FAILURE,
  GET_VENDOR_INVOICE_REQUEST,
  GET_VENDOR_INVOICE_SUCCESS,
  GET_VENDOR_INVOICE_FAILURE,
  UPLOAD_VENDOR_INVOICE_DATA_REQUEST,
  UPLOAD_VENDOR_INVOICE_DATA_SUCCESS,
  UPLOAD_VENDOR_INVOICE_DATA_FAILURE,
} from "./purchaseOrderNewTypes";

let baseUrl = Config.baseUrl;

// Common headers
const headersWith = (jwtToken) => ({
  headers: { Authorization: `Bearer ${jwtToken}` },
});

// GET list (paginated)
const getPurchaseOrderRequest = () => ({ type: GET_PURCHASE_ORDER_REQUEST });
const getPurchaseOrderSuccess = (payload) => ({
  type: GET_PURCHASE_ORDER_SUCCESS,
  payload,
});
const getPurchaseOrderFailure = (error) => ({
  type: GET_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const getPurchaseOrderNew = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/get_created_po_client?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => dispatch(getPurchaseOrderSuccess(response.data)))
      .catch((err) => dispatch(getPurchaseOrderFailure(err.message)));
  };
};

// Released POs
const getReleasedPurchaseOrderRequest = () => ({
  type: GET_RELEASED_PURCHASE_ORDERS_REQUEST,
});
const getReleasedPurchaseOrderSuccess = (payload) => ({
  type: GET_RELEASED_PURCHASE_ORDERS_SUCCESS,
  payload,
});
const getReleasedPurchaseOrderFailure = (error) => ({
  type: GET_RELEASED_PURCHASE_ORDERS_FAILURE,
  payload: error,
});

const getReleasedPurchaseOrder = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getReleasedPurchaseOrderRequest());
    const url = `${baseUrl}/purchase_order/get_released?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) =>
        dispatch(getReleasedPurchaseOrderSuccess(response.data))
      )
      .catch((err) => dispatch(getReleasedPurchaseOrderFailure(err.message)));
  };
};

// Accepted POs
const getAcceptedPurchaseOrdersRequest = () => ({
  type: GET_ACCEPTED_PURCHASE_ORDERS_REQUEST,
});
const getAcceptedPurchaseOrdersSuccess = (payload) => ({
  type: GET_ACCEPTED_PURCHASE_ORDERS_SUCCESS,
  payload,
});
const getAcceptedPurchaseOrdersFailure = (error) => ({
  type: GET_ACCEPTED_PURCHASE_ORDERS_FAILURE,
  payload: error,
});

const getAcceptedPurchaseOrders = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getAcceptedPurchaseOrdersRequest());
    const url = `${baseUrl}/purchase_order/get_released?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) =>
        dispatch(getAcceptedPurchaseOrdersSuccess(response.data))
      )
      .catch((err) => dispatch(getAcceptedPurchaseOrdersFailure(err.message)));
  };
};

// CREATE
const createPurchaseOrderRequest = () => ({
  type: CREATE_PURCHASE_ORDER_REQUEST,
});
const createPurchaseOrderSuccess = (payload) => ({
  type: CREATE_PURCHASE_ORDER_SUCCESS,
  payload,
});
const createPurchaseOrderFailure = (error) => ({
  type: CREATE_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const createPurchaseOrderNew = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(createPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPurchaseOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPurchaseOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// EDIT
const editPurchaseOrderRequest = () => ({ type: EDIT_REQ_QTY_REQUEST });
const editPurchaseOrderSuccess = (payload) => ({
  type: EDIT_REQ_QTY_SUCCESS,
  payload,
});
const editPurchaseOrderFaliure = (error) => ({
  type: EDIT_REQ_QTY_FAILURE,
  payload: error,
});

const editPurchaseOrderNew = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(editPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editPurchaseOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editPurchaseOrderFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// DELETE
const deletePurchaseOrderRequest = () => ({
  type: DELETE_PURCHASE_ORDER_REQUEST,
});
const deletePurchaseOrderSuccess = (payload) => ({
  type: DELETE_PURCHASE_ORDER_SUCCESS,
  payload,
});
const deletePurchaseOrderFaliure = (error) => ({
  type: DELETE_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const deletePurchaseOrderNew = (purchaseOrderId, userId, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(deletePurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/delete?purchaseOrderId=${purchaseOrderId}&userId=${userId}`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deletePurchaseOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deletePurchaseOrderFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadForPurchaseOrderRequest = () => ({
  type: UPLOAD_EXCEL_FOR_PURCHASE_ORDER_REQUEST,
});
const uploadForPurchaseOrderSuccess = (payload) => ({
  type: UPLOAD_EXCEL_FOR_PURCHASE_ORDER_SUCCESS,
  payload,
});
const uploadForPurchaseOrderFailure = (error) => ({
  type: UPLOAD_EXCEL_FOR_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const uploadForPurchaseOrderNew = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(uploadForPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/upload_invoice`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForPurchaseOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForPurchaseOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// RELEASE (client single/multi release flow)

const publishPurchaseOrderRequest = () => ({
  type: PUBLISH_PURCHASE_ORDER_REQUEST,
});
const publishPurchaseOrderSuccess = (payload) => ({
  type: PUBLISH_PURCHASE_ORDER_SUCCESS,
  payload,
});
const publishPurchaseOrderFailure = (error) => ({
  type: PUBLISH_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const publishPurchaseOrder = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(publishPurchaseOrderRequest());
    const url = `${baseUrl}/purchase_order/release`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(publishPurchaseOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(publishPurchaseOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// publishPoNew (client bulk publish)
const publishPoRequest = () => ({ type: PUBLISH_PO_REQUEST });
const publishPoSuccess = (payload) => ({ type: PUBLISH_PO_SUCCESS, payload });
const publishPoFaliure = (error) => ({
  type: PUBLISH_PO_FAILURE,
  payload: error,
});

const publishPoNew = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(publishPoRequest());
    const url = `${baseUrl}/sp/purchase_order/publish`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(publishPoSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(publishPoFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// Not-accepted list for vendor inbox
const getNotAcceptedPurchasedOrdersRequest = () => ({
  type: GET_NOTACCEPTEDPURCHASEDORDERS_REQUEST,
});
const getNotAcceptedPurchasedOrdersSuccess = (payload) => ({
  type: GET_NOTACCEPTEDPURCHASEDORDERS_SUCCESS,
  payload,
});
const getNotAcceptedPurchasedOrdersFailure = (error) => ({
  type: GET_NOTACCEPTEDPURCHASEDORDERS_FAILURE,
  payload: error,
});

const getNotAcceptedPurchasedOrders = (emailId) => {
  return (dispatch) => {
    dispatch(getNotAcceptedPurchasedOrdersRequest());
    const url = `${baseUrl}/vendor/get_not_accepted_purchase_order_without_itemList?email=${emailId}`;
    axios
      .get(url)
      .then((response) =>
        dispatch(getNotAcceptedPurchasedOrdersSuccess(response.data))
      )
      .catch((err) =>
        dispatch(getNotAcceptedPurchasedOrdersFailure(err.message))
      );
  };
};

// Vendor ACCEPT
const acceptPoRequest = () => ({ type: UPDATE_ACCEPTPO_REQUEST });
const acceptPoSuccess = (payload) => ({
  type: UPDATE_ACCEPTPO_SUCCESS,
  payload,
});
const acceptPoFaliure = (error) => ({
  type: UPDATE_ACCEPTPO_FAILURE,
  payload: error,
});

const acceptPoNew = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(acceptPoRequest());
    const url = `${baseUrl}/sp/purchase_order/accept`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(acceptPoSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(acceptPoFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// Vendor REJECT
const rejectPoRequest = () => ({ type: UPDATE_REJECTPO_REQUEST });
const rejectPoSuccess = (payload) => ({
  type: UPDATE_REJECTPO_SUCCESS,
  payload,
});
const rejectPoFailure = (error) => ({
  type: UPDATE_REJECTPO_FAILURE,
  payload: error,
});

const rejectPo = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(rejectPoRequest());
    const url = `${baseUrl}/sp/purchase_order/reject`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(rejectPoSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(rejectPoFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// OPTIONAL: Vendor ACCEPT BULK (separate loader)
const acceptPoBulkRequest = () => ({ type: UPDATE_ACCEPTPO_BULK_REQUEST });
const acceptPoBulkSuccess = (payload) => ({
  type: UPDATE_ACCEPTPO_BULK_SUCCESS,
  payload,
});
const acceptPoBulkFailure = (error) => ({
  type: UPDATE_ACCEPTPO_BULK_FAILURE,
  payload: error,
});

const acceptPoBulk = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(acceptPoBulkRequest());
    const url = `${baseUrl}/sp/purchase_order/accept`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(acceptPoBulkSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(acceptPoBulkFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// OPTIONAL: Vendor REJECT BULK (separate loader)
const rejectPoBulkRequest = () => ({ type: UPDATE_REJECTPO_BULK_REQUEST });
const rejectPoBulkSuccess = (payload) => ({
  type: UPDATE_REJECTPO_BULK_SUCCESS,
  payload,
});
const rejectPoBulkFailure = (error) => ({
  type: UPDATE_REJECTPO_BULK_FAILURE,
  payload: error,
});

const rejectPoBulk = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(rejectPoBulkRequest());
    const url = `${baseUrl}/purchase_order/reject`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(rejectPoBulkSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(rejectPoBulkFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// Vendor metadata
const getVendorCodesRequest = () => ({ type: GET_VENDOR_CODE_REQUEST });
const getVendorCodesSuccess = (payload) => ({
  type: GET_VENDOR_CODE_SUCCESS,
  payload,
});
const getVendorCodesFailure = (error) => ({
  type: GET_VENDOR_CODE_FAILURE,
  payload: error,
});

const getVendorCodes = (jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getVendorCodesRequest());
    const url = `${baseUrl}/vendor/get_approved`;
    axios
      .get(url, headers)
      .then((response) => dispatch(getVendorCodesSuccess(response.data)))
      .catch((err) => dispatch(getVendorCodesFailure(err.message)));
  };
};

// Delivery plant
const getDeliveryPlantForPORequest = () => ({
  type: GET_DELIVERY_PLANT_FOR_PO_REQUEST,
});
const getDeliveryPlantForPOSuccess = (payload) => ({
  type: GET_DELIVERY_PLANT_FOR_PO_SUCCESS,
  payload,
});
const getDeliveryPlantForPOFailure = (error) => ({
  type: GET_DELIVERY_PLANT_FOR_PO_FAILURE,
  payload: error,
});

const getDeliveryPlantForPO = (id, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getDeliveryPlantForPORequest());
    const url = `${baseUrl}/asn/get_delivery_plant_for_po?purchaseOrderId=${id}`;
    axios
      .get(url, headers)
      .then((response) => dispatch(getDeliveryPlantForPOSuccess(response.data)))
      .catch((err) => dispatch(getDeliveryPlantForPOFailure(err.message)));
  };
};

// Unloading point
const getUnloadingPointForPORequest = () => ({
  type: GET_UNLOADING_POINT_FOR_PO_REQUEST,
});
const getUnloadingPointForPOSuccess = (payload) => ({
  type: GET_UNLOADING_POINT_FOR_PO_SUCCESS,
  payload,
});
const getUnloadingPointForPOFailure = (error) => ({
  type: GET_UNLOADING_POINT_FOR_PO_FAILURE,
  payload: error,
});

const getUnloadingPointForPO = (id, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getUnloadingPointForPORequest());
    const url = `${baseUrl}/asn/get_unloading_point_for_po?purchaseOrderId=${id}`;
    axios
      .get(url, headers)
      .then((response) =>
        dispatch(getUnloadingPointForPOSuccess(response.data))
      )
      .catch((err) => dispatch(getUnloadingPointForPOFailure(err.message)));
  };
};

const getVendorPurchaseOrderRequest = () => ({
  type: GET_VENDOR_PURCHASE_ORDER_REQUEST,
});
const getVendorPurchaseOrderSuccess = (payload) => ({
  type: GET_VENDOR_PURCHASE_ORDER_SUCCESS,
  payload,
});
const getVendorPurchaseOrderFailure = (error) => ({
  type: GET_VENDOR_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const getVendorPurchaseOrder = (
  email,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getVendorPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/get_published_po_for_vendor?email=${email}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) =>
        dispatch(getVendorPurchaseOrderSuccess(response.data))
      )
      .catch((err) => dispatch(getVendorPurchaseOrderFailure(err.message)));
  };
};

const getVendorInboxPurchaseOrder = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getVendorPurchaseOrderRequest());
    const url = `${baseUrl}/sp/purchase_order/get_not_accepted?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) =>
        dispatch(getVendorPurchaseOrderSuccess(response.data))
      )
      .catch((err) => dispatch(getVendorPurchaseOrderFailure(err.message)));
  };
};

const getClientRejectedPosRequest = () => ({
  type: GET_CLIENT_REJECTED_POS_REQUEST,
});
const getClientRejectedPosSuccess = (payload) => ({
  type: GET_CLIENT_REJECTED_POS_SUCCESS,
  payload,
});
const getClientRejectedPosFailure = (error) => ({
  type: GET_CLIENT_REJECTED_POS_FAILURE,
  payload: error,
});

const getVendorRejectedPosRequest = () => ({
  type: GET_VENDOR_REJECTED_POS_REQUEST,
});
const getVendorRejectedPosSuccess = (payload) => ({
  type: GET_VENDOR_REJECTED_POS_SUCCESS,
  payload,
});
const getVendorRejectedPosFailure = (error) => ({
  type: GET_VENDOR_REJECTED_POS_FAILURE,
  payload: error,
});

// Client rejected list
const getClientRejectedPurchaseOrders = (
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getClientRejectedPosRequest());
    const url = `${baseUrl}/sp/purchase_order/get_rejected_po?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    return axios
      .get(url, headers)
      .then((response) => dispatch(getClientRejectedPosSuccess(response.data)))
      .catch((err) => dispatch(getClientRejectedPosFailure(err.message)));
  };
};

// Vendor rejected list
const getVendorRejectedPurchaseOrders = (
  email,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(getVendorRejectedPosRequest());
    const url = `${baseUrl}/sp/purchase_order/get_rejected_po_for_vendor?email=${email}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    return axios
      .get(url, headers)
      .then((response) => dispatch(getVendorRejectedPosSuccess(response.data)))
      .catch((err) => dispatch(getVendorRejectedPosFailure(err.message)));
  };
};

// -------- CLIENT ----------
const getAcceptedPoClientRequest = () => ({
  type: GET_ACCEPTED_PO_CLIENT_REQUEST,
});

const getAcceptedPoClientSuccess = (payload) => ({
  type: GET_ACCEPTED_PO_CLIENT_SUCCESS,
  payload,
});

const getAcceptedPoClientFailure = (error) => ({
  type: GET_ACCEPTED_PO_CLIENT_FAILURE,
  payload: error,
});

const getAcceptedPoClient = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAcceptedPoClientRequest());

    const url = `${baseUrl}/sp/purchase_order/get_accepted_po?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAcceptedPoClientSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAcceptedPoClientFailure(err.message));
      });
  };
};

// -------- VENDOR ----------
const getAcceptedPoVendorRequest = () => ({
  type: GET_ACCEPTED_PO_VENDOR_REQUEST,
});

const getAcceptedPoVendorSuccess = (payload) => ({
  type: GET_ACCEPTED_PO_VENDOR_SUCCESS,
  payload,
});

const getAcceptedPoVendorFailure = (error) => ({
  type: GET_ACCEPTED_PO_VENDOR_FAILURE,
  payload: error,
});

const getAcceptedPoVendor = (email, pageNo, rowsPerPage, search, jwtToken) => {
  const headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAcceptedPoVendorRequest());

    const url = `${baseUrl}/sp/purchase_order/get_accepted_po_for_vendor?email=${email}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAcceptedPoVendorSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAcceptedPoVendorFailure(err.message));
      });
  };
};

const getAttechmentClientRequest = () => ({
  type: GET_ATTACHMENT_CLIENT_REQUEST,
});

const getAttechmentClientSuccess = (payload) => ({
  type: GET_ATTACHMENT_CLIENT_SUCCESS,
  payload,
});

const getAttechmentClientFailure = (error) => ({
  type: GET_ATTACHMENT_CLIENT_FAILURE,
  payload: error,
});

// const getAttechmentClient = ({ file_name, file_type, purchaseOrderId }, jwtToken) => {
//   const headers = headersWith(jwtToken);
//   return (dispatch) => {
//     dispatch(getAttechmentClientRequest());

//     const url = `${baseUrl}/sp/purchase_order/get_attachment`;

//     axios
//       .get(url, {
//         ...headers,
//         params: { file_name, file_type, purchaseOrderId },
//       })
//       .then((response) => {
//         const urlOut = response?.data?.data?.url || response?.data?.url || "";
//         dispatch(getAttechmentClientSuccess(urlOut));
//       })
//       .catch((err) => {
//         const msg =
//           err?.response?.data?.data?.msg ||
//           err?.response?.data?.message ||
//           err?.message ||
//           "Failed to fetch attachment";
//         dispatch(getAttechmentClientFailure(msg));
//       });
//   };
// };.

const getAttechmentClient = (
  { file_name, file_type, purchaseOrderId },
  jwtToken
) => {
  const headers = headersWith(jwtToken);
  return async (dispatch) => {
    dispatch(getAttechmentClientRequest());

    try {
      const url = `${baseUrl}/sp/purchase_order/get_attachment`;

      const response = await axios.get(url, {
        ...headers,
        params: { file_name, file_type, purchaseOrderId },
      });

      const result = response?.data || {};
      const urlOut = result?.data?.url || result?.url || "";

      dispatch(getAttechmentClientSuccess(urlOut));

      return {
        status: result?.status || false,
        msg: result?.msg || "",
        url: urlOut,
      };
    } catch (err) {
      const msg =
        err?.response?.data?.data?.msg ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch attachment";

      dispatch(getAttechmentClientFailure(msg));

      return { status: false, msg };
    }
  };
};

const getVendorInvoiceRequest = () => ({
  type: GET_VENDOR_INVOICE_REQUEST,
});

const getVendorInvoiceSuccess = (payload) => ({
  type: GET_VENDOR_INVOICE_SUCCESS,
  payload,
});

const getVendorInvoiceFailure = (error) => ({
  type: GET_VENDOR_INVOICE_FAILURE,
  payload: error,
});

const getVendorInvoice = (
  { file_name, file_type, purchaseOrderId },
  jwtToken
) => {
  const headers = headersWith(jwtToken);
  return async (dispatch) => {
    dispatch(getVendorInvoiceRequest());

    try {
      const url = `${baseUrl}/sp/purchase_order/get_invoice`;

      const response = await axios.get(url, {
        ...headers,
        params: { file_name, file_type, purchaseOrderId },
      });

      const result = response?.data || {};
      const urlOut = result?.data?.url || result?.url || "";

      dispatch(getVendorInvoiceSuccess(urlOut));

      return {
        status: result?.status || false,
        msg: result?.msg || "",
        url: urlOut,
      };
    } catch (err) {
      const msg =
        err?.response?.data?.data?.msg ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch attachment";

      dispatch(getVendorInvoiceFailure(msg));

      return { status: false, msg };
    }
  };
};

const uploadVendorInvoiceDataRequest = () => ({
  type: UPLOAD_VENDOR_INVOICE_DATA_REQUEST,
});

const uploadVendorInvoiceDataSuccess = (payload) => ({
  type: UPLOAD_VENDOR_INVOICE_DATA_SUCCESS,
  payload,
});

const uploadVendorInvoiceDataFailure = (error) => ({
  type: UPLOAD_VENDOR_INVOICE_DATA_FAILURE,
  payload: error,
});

const uploadVendorInvoiceData = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(uploadVendorInvoiceDataRequest());
    const url = `${baseUrl}/sp/invoice/raise_invoice`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadVendorInvoiceDataSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadVendorInvoiceDataFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


export {
  getPurchaseOrderNew,
  createPurchaseOrderNew,
  editPurchaseOrderNew,
  deletePurchaseOrderNew,
  uploadForPurchaseOrderNew,
  publishPurchaseOrder,
  publishPoNew,
  getReleasedPurchaseOrder,
  getAcceptedPurchaseOrders,
  getNotAcceptedPurchasedOrders,
  getVendorCodes,
  getDeliveryPlantForPO,
  getUnloadingPointForPO,
  // Vendor decisions
  acceptPoNew,
  rejectPo,
  // Optional dedicated bulk
  acceptPoBulk,
  rejectPoBulk,
  getVendorPurchaseOrder,
  getVendorInboxPurchaseOrder,
  getClientRejectedPurchaseOrders,
  getVendorRejectedPurchaseOrders,
  getAcceptedPoVendor,
  getAcceptedPoClient,
  getAttechmentClient,
  getVendorInvoice,
  uploadVendorInvoiceData
};
